import React from 'react'

const QrLogin = () => {
  return (
    <div>
      Đăng nhập
    </div>
  )
}

export default QrLogin
